export default (theme) => ({
  formWrapper: {
    zIndex: 100,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      padding: 12,
      width: 'auto',
      marginBottom: 0,
    },
    [theme.breakpoints.down('md')]: {
      padding: 0,
    },
  },
  controlButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
});
